<template lang="pug">
  div
    div Send {{ catalog.product_retailer_id ? 'single' : 'multiple' }} product from WhatsApp Catalog
    div(class="catalog")
      div(v-if="catalog.product_retailer_id")
        div(:class="{'label-width': catalog.product_retailer_id}") product_retailer_id
        span :
        strong {{ catalog.product_retailer_id }}
      div
        div(:class="{'label-width': catalog.product_retailer_id}") catalog_id
        span :
        strong {{ catalog.catalog_id }}
</template>

<script>

export default {
  name: 'QiscusCatalogComment',
  props: ['catalog'],
};
</script>


<style lang="stylus">
  @import '../assets/stylus/_variables.styl'
  .catalog
    margin: 1rem 0
    display: flex
    flex-direction: column
    div
      display: flex
      flex-wrap: wrap
      column-gap: 6px
    .label-width
      &:first-child
        min-width: 124px
</style>


// WEBPACK FOOTER //
// src/components/CommentCatalog.vue